import { Download } from '@components/icons'
import FAQAccordion from '@components/ui/FAQAccordion'
import WYSIWYG from '@components/ui/WYSIWYG'
import Link from 'next/link'
interface Props {
  slice: any
}

const ColourPdpSpecs = ({ slice }: Props) => {
  const title = slice?.primary?.title
  const text = slice?.primary?.text
  const background = slice?.primary?.backgroundColour
  const file = slice?.primary?.downloadFile
  const linkTitle = slice?.primary?.linkTitle
  const accordion = slice?.items
  return <>
    <div className="background w-full py-16 lg:pt-30 lg:pb-20">
      <div className="wrapper grid grid-cols-1 gap-0 overflow-hidden lg:grid-cols-6 lg:grid-rows-2 lg:gap-8">
        <div className="mb-2 flex flex-col text-brand-dark-grey lg:col-span-2 lg:row-span-2">
          {title && <div className="heading-3 pb-2">{title}</div>}
          {text && (
            <div className="body-1 pt-1 ">
              <WYSIWYG content={text} />
            </div>
          )}
          <div className="flex items-center pt-4">
            {file?.url && (
              <div className="pr-3">
                <Download />
              </div>
            )}
            <Link href={file?.url || '/'} legacyBehavior>
              <a
                href={file?.url || '/'}
                className="body-1 text-decoration-line: text-brand-dark-grey underline"
              >
                {linkTitle}
              </a>
            </Link>
          </div>
        </div>
        <div className="accordion lg:col-span-3 lg:col-start-4 lg:row-span-2">
          <FAQAccordion accordion={accordion} />
        </div>
      </div>
    </div>
    <style jsx>
      {`
        .background {
          background-color: ${background};
        }
      `}
    </style>
  </>;
}

export default ColourPdpSpecs
